// File: /opt/dev_environment/assets/workspace/app-init/src/pages/auth/ResetPasswordPage.js

import React, { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import AuthService from '../../services/authService';
import './AuthPages.css';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const validatePassword = (password) => {
    if (password.length < 8) {
      return 'Passwort muss mindestens 8 Zeichen lang sein';
    }
    if (!/[A-Z]/.test(password)) {
      return 'Passwort muss mindestens einen Großbuchstaben enthalten';
    }
    if (!/[a-z]/.test(password)) {
      return 'Passwort muss mindestens einen Kleinbuchstaben enthalten';
    }
    if (!/[0-9]/.test(password)) {
      return 'Passwort muss mindestens eine Zahl enthalten';
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwörter stimmen nicht überein');
      return;
    }

    const passwordError = validatePassword(password);
    if (passwordError) {
      setError(passwordError);
      return;
    }

    if (!token) {
      setError('Ungültiger oder fehlender Token');
      return;
    }

    setLoading(true);

    try {
      await AuthService.confirmPasswordReset(token, password);
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Ein Fehler ist aufgetreten');
    } finally {
      setLoading(false);
    }
  };

  // No token provided
  if (!token) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-status-card">
            <span className="auth-status-card__icon" role="img" aria-hidden="true">⚠️</span>
            <h2 className="auth-status-card__title">Ungültiger Link</h2>
            <p className="auth-status-card__message">
              Der Link zum Zurücksetzen des Passworts ist ungültig oder abgelaufen.
            </p>
            <Link to="/forgot-password" className="auth-action-btn">
              Neuen Link anfordern
            </Link>
          </div>
        </div>
      </div>
    );
  }

  // Success state
  if (success) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-status-card">
            <span className="auth-status-card__icon" role="img" aria-hidden="true">✅</span>
            <h2 className="auth-status-card__title">Passwort geändert</h2>
            <p className="auth-status-card__message">
              Dein Passwort wurde erfolgreich geändert. Du kannst dich jetzt anmelden.
            </p>
            <Link to="/login" className="auth-action-btn">
              Zur Anmeldung
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-card__header">
          <div className="auth-card__logo">
            <span className="auth-card__logo-icon" role="img" aria-label="Karteikasten">🗃️</span>
            Vokabelkasten
          </div>
          <h2 className="auth-card__title">Neues Passwort setzen</h2>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          {error && (
            <div className="auth-error" role="alert">
              {error}
            </div>
          )}

          <div className="auth-field">
            <label className="auth-field__label" htmlFor="reset-password">
              Neues Passwort
            </label>
            <input
              id="reset-password"
              className="auth-field__input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="new-password"
            />
            <span className="auth-field__hint">
              Mind. 8 Zeichen, Groß- und Kleinbuchstaben, eine Zahl
            </span>
          </div>

          <div className="auth-field">
            <label className="auth-field__label" htmlFor="reset-confirm">
              Passwort bestätigen
            </label>
            <input
              id="reset-confirm"
              className="auth-field__input"
              type="password"
              required
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="new-password"
            />
          </div>

          <button
            className="auth-submit-btn"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="auth-submit-btn__spinner" />
                Wird gespeichert…
              </>
            ) : (
              'Passwort ändern'
            )}
          </button>
        </form>
      </div>
    </div>
  );
}